<template>
  <div id="app">
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import config from '@/util/config'
export default {
  name: 'App',
  components:{

  },
  created(){
    if(this.$route.name !== 'login'){
      document.title = '海纳视频面试'
    }
  },
  mounted(){
    // 友盟统计
    let e = document.createElement('script')
    e.src = config.umeng
    e.type = 'text/javascript'
    document.body.appendChild(e)
  },
  methods: {

  }
}
</script>

<style>
body{
  margin: 0;
}
#app {
  width: 100%;
  height: 100vh;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}

.el-button{
    font-size: 13px;
    font-weight: normal;
}

</style>



// WEBPACK FOOTER //
// src/App.vue